<div class="table-container">
  <ion-row class="main-container">
    <div class="header-container">

      <ion-col *ngIf="!confirmationView && showEditIcon" class="checkbox" size="1">
        <app-form-checkbox  (onChange)="toggleAllCheckBoxes($event,0)" [options]="checkBoxOptions">
        </app-form-checkbox>
        &nbsp;
      </ion-col>


      <ion-col class="header" [ngClass]="{'header-shift': !showEditIcon}" size="2" *ngFor="let item of config">
       {{showRequiredAsterisk ? '* ' : ''}} {{item}}
      </ion-col>
    </div>
  </ion-row>

  <ion-row *ngIf="formGroup" [formGroup]="formGroup">
    <app-edit-recurring-shift-list-item  [class] = "{'create-shift': currentView === 'create-shift'}" [companyType]="companyType" [settings]="settings" class="row-container" *ngFor="let item of data; let i = index"
    (onToggleCheckBox)="toggleCheckBox($event, i)"
     [formArrayName]="formGroupName" [showEditIcon]="showEditIcon" [confirmationView]="confirmationView"  [config]="config" [control]="getControl(item.index)"   >
    </app-edit-recurring-shift-list-item>
  </ion-row>
  
  <ion-row *ngIf="!formGroup">
    <app-edit-recurring-shift-list-item [class] = "{'create-shift': currentView === 'create-shift'}" class="row-container" *ngFor="let item of data; let i = index"
     [confirmationView]="confirmationView" [data]="item"  [config]="config"  >
    </app-edit-recurring-shift-list-item>
  </ion-row>
</div>